import React, { useState } from "react";
import { X, Minus, Plus } from "lucide-react";

export default function AddToCartModal({ product, onAddToCart, onClose }) {
  const [quantity, setQuantity] = useState(1);
  const amount = (quantity * product.price).toFixed(2);

  const handleAdd = () => {
    onAddToCart(product, quantity);
    onClose();
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    if (value === "" || (parseInt(value) > 0 && !isNaN(parseInt(value)))) {
      setQuantity(parseInt(value) || "");
    }
  };

  const handleBlur = () => {
    if (quantity === "") {
      setQuantity(1);
    }
  };

  const increaseQty = () => setQuantity((prev) => (prev || 0) + 1);
  const decreaseQty = () =>
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-[fadeIn_.2s_ease-in-out]">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h3 className="text-xl font-bold text-gray-800">
            🛒 Add to Cart
          </h3>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* Product Info */}
        <div className="px-6 py-5 text-center space-y-3">
          <div className="text-lg font-semibold text-gray-800">
            {product.name}
          </div>

          <div className="text-2xl font-bold text-teal-700">
            ₹{product.price.toFixed(2)}
          </div>
        </div>

        {/* Quantity Section */}
        <div className="px-6 pb-6 space-y-4">

          <label className="block text-sm font-medium text-gray-500 text-center">
            Select Quantity
          </label>

          <div className="flex items-center justify-center gap-4">

            <button
              onClick={decreaseQty}
              className="p-3 rounded-full bg-gray-100 hover:bg-gray-200 transition"
            >
              <Minus size={18} />
            </button>

            <input
              type="number"
              value={quantity}
              onChange={handleQuantityChange}
              onBlur={handleBlur}
              className="w-20 text-center text-xl font-semibold border border-gray-300 rounded-lg py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
              autoFocus
            />

            <button
              onClick={increaseQty}
              className="p-3 rounded-full bg-gray-100 hover:bg-gray-200 transition"
            >
              <Plus size={18} />
            </button>

          </div>

          {/* Amount */}
          <div className="bg-teal-50 rounded-xl p-4 flex justify-between items-center">
            <span className="text-gray-600 font-medium">
              Total Amount
            </span>
            <span className="text-2xl font-bold text-teal-700">
              ₹{amount}
            </span>
          </div>

          {/* Buttons */}
          <div className="flex gap-4 pt-2">
            <button
              onClick={onClose}
              className="w-full py-3 rounded-xl bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300 transition"
            >
              Cancel
            </button>

            <button
              onClick={handleAdd}
              className="w-full py-3 rounded-xl bg-gradient-to-r from-teal-500 to-emerald-600 text-white font-semibold shadow-lg hover:shadow-xl hover:scale-[1.02] transition"
            >
              Add ₹{amount}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
